const validator = require("email-validator");
const mailcheck = require("mailcheck");

export default () => {
  function init() {
    class ArticleQuickAdd extends HTMLElement {
      constructor() {
        super();

        if (this.querySelector('select.quick-adder')) {
          this.querySelector('select.quick-adder').addEventListener('change', (e) => {
            this.setAttribute('data-id', e.currentTarget.value);
            const select = e.target;
            const desc = select.selectedOptions[0].text;
            this.setAttribute('data-name', desc);


            if(this.getAttribute('data-should-change') == 'true') {
              this.querySelector('#dynamic-bis-variant-thanks').innerHTML = `${this.getAttribute('data-base-name')} - ${desc}`;
            }

          });
        }

        if (this.querySelector('.quick-add__add')) {

          this.querySelector('.quick-add__add').addEventListener('click', (e) => {
            e.preventDefault();
            const id = this.getAttribute('data-id');

            console.log(id.split('/').shift());

            if (id.includes('/')) {
              const i = id.split('/').shift();

              if(this.getAttribute('data-id') == "please select") {

                this.querySelector('select.quick-adder').classList.add('required');
                this.querySelector('.required-prompt').classList.remove('visually-hidden');

                setTimeout(()=> {

                  this.querySelector('select.quick-adder').classList.remove('required');
                  this.querySelector('.required-prompt').classList.add('visually-hidden');

                },4000)
                
      
              } else {
                this.addItemToCart(id, e);
              }

            } else {

              if(this.getAttribute('data-id') == "please select") {

                this.querySelector('select.quick-adder').classList.add('required');
                this.querySelector('.required-prompt').classList.remove('visually-hidden');

                setTimeout(()=> {

                  this.querySelector('select.quick-adder').classList.remove('required');
                  this.querySelector('.required-prompt').classList.add('visually-hidden');

                },4000)
                
      
              } else {
                this.addItemToCart(id, e);
              }

            }

          });
        }

        // disable actions when no variant is selected
        if(this.getAttribute('data-id') == "please select") {
          // this.querySelector('.quick-add__add').classList.add('disabled');
          // this.querySelector('.bis-button').classList.add('disabled');

        } else {
          this.querySelector('.quick-add__add').classList.remove('disabled');
          this.querySelector('.bis-button').classList.remove('disabled');
        }

      }

      static get observedAttributes() {
        return ['data-id', 'data-name'];
      }

      attributeChangedCallback(name, oldValue, newValue) {
        const _id = this.getAttribute("data-id");

        if (name === "data-id") {
          if (oldValue != null) {
            let id_only;

            if(this.getAttribute('data-id') == "please select") {
              this.querySelector('.quick-add__add').classList.add('disabled');
              this.querySelector('.bis-button').classList.add('disabled');
            } else {
              this.querySelector('.quick-add__add').classList.remove('disabled');
              this.querySelector('.bis-button').classList.remove('disabled');
            }

            if (_id.includes('/')) {
              id_only = _id.split('/').shift();
            } else {
              id_only = _id;
            }
            this.setAttribute('data-notify-id', id_only);
            this.resync(_id, this);
          }
        }
      }


      async addItemToCart(_id, e) {

        if(_id.includes("/")) {
          _id = _id.split("/").shift();
        }

        try {

          const formData = {
            items: [{
              id: _id,
              quantity: 1
            }]
          };

          const addToCartRequest = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          });

          const cartResponse = await addToCartRequest.json();
          Karmoon.EventBus.emit('AddToCart:itemAdded', cartResponse);

        } catch (err) {
          console.error(`There was an errror adding the product to cart: ${err}`);
        }

      }

      async resync(id, p) {

        try {
          const handle = id.split('/').pop();
          const _id = id.split('/').shift();

          const productRequest = await fetch(`/products/${handle}.js`);
          const productData = await productRequest.json();

          const variants = productData?.variants;

          let current;

          variants.map((v) => {
            if (v.id == _id) {
              current = v;
            }
          });

          const thisID = p.id;
          const dynamicTitle = thisID.replace('qa-', 'bis-modal-');

          if(document.querySelector(`#${dynamicTitle} #dynamic-bis-variant-title`)) {
            document.querySelector(`#${dynamicTitle} #dynamic-bis-variant-title`).innerHTML = current?.name;
          }

          if (current.available == false) {
            p.querySelector('.quick-add__add').classList.add('visually-hidden');
            p.querySelector('.bis-button').classList.remove('visually-hidden');
          } else {
            p.querySelector('.quick-add__add').classList.remove('visually-hidden');
            p.querySelector('.bis-button').classList.add('visually-hidden');
          }


        } catch (error) {
          console.log(error);
        }

      }

      }

    customElements.define("article-quick-add", ArticleQuickAdd);


    // bump
    class BackInStockQuickAdd extends HTMLElement {
      constructor() {
        super();
        this.addEventListener("click", (e) => {
          const _form = e.target.id;
          console.log("Clicked element ID:", _form);
          const t = document.querySelector(`.bis-button#${_form}`);
          const p = t.parentElement.parentElement.parentElement.parentElement.parentElement;
          const _el = p.querySelector('.bis-modal');
          _el.classList.remove("visually-hidden");
        });
      }
    }

    customElements.define("back-in-stock-qa", BackInStockQuickAdd);


    class NotifyMeWrapperQuickAdd extends HTMLElement {
      constructor() {
        super();
        const _email = this.querySelector("#email_bis");
        const _emailConfirmation = this.querySelector("#fieldEmailConfirmation");
        const shouldSignup = this.querySelector("#email-for-signup");

        this.querySelector('.bis-closer').addEventListener('click', () => {
          this.closest(".bis-modal").classList.add("visually-hidden");
        });

        // add domains to exlucde
        const domains = [
          "gmail.com",
          "outlook.com",
          "hotmail.com",
          "hotmail.co.uk",
          "hotmail.fr",
          "msn.com",
          "aol.com",
          "icloud.com",
          "talktalk.com",
          "yahoo.com",
          "proton.com",
          "proton.me",
          "sky.com",
          "doctors.org.uk",
          "doctors.org",
          "doctors.uk",
          "me.com",
        ];
        const secondLevelDomains = ["hotmail"];
        const topLevelDomains = [
          "com",
          "net",
          "org",
          "uk",
          "gov",
          "ac",
          "co.uk",
          "ac.uk",
          "sch.uk",
          "doctors",
          "me",
        ];

        this.querySelector("form").addEventListener("submit", (e) => {
          e.preventDefault();

          const targetID = this.id.replace('bis-modal-', '');
          const idRef = document.querySelector(`#qa-${targetID}`);

          const _id = idRef.getAttribute('data-notify-id');

          const isEmailValid = validator.validate(_email.value);

          const isEmailCorrect = mailcheck.run({
            domains,
            topLevelDomains,
            email: _email.value,
            suggested: (res) => {
              return res;
            },
          });

          if (isEmailValid) {
            if (isEmailCorrect?.full) {
              _emailConfirmation.classList.remove("visually-hidden");
              if (_emailConfirmation.value !== "") {
                this.checkEmailsMatch(_id);
              }
            } else {
              this.subscribeCustomer(_email.value, _id, this);
              if (shouldSignup.checked) {
                this.subscribeCustomerToMailList(_email.value, _id);
              }
            }
          } else {
            _emailConfirmation.classList.remove("visually-hidden");
            if (_emailConfirmation.value !== "") {
              this.checkEmailsMatch(_id);
            }
          }
        });
      }

      static get observedAttributes() {
        return ["data-sent"];
      }

      attributeChangedCallback(name, oldValue, newValue) {
        const d = this.getAttribute("data-sent");
        if (name === "data-sent") {
          this.resetForm();
        }
      }

      checkEmailsMatch(id) {
        const _email = this.querySelector("#email_bis");
        const _emailConfirmation = this.querySelector("#fieldEmailConfirmation");
        const shouldSignup = this.querySelector("#email-for-signup");

        if (_email.value !== _emailConfirmation.value) {
          this.querySelector("#emails-do-not-match").classList.remove(
            "visually-hidden",
          );

          setTimeout(() => {
            this.querySelector("#emails-do-not-match").classList.add(
              "visually-hidden",
            );
          }, 4500);
        } else {
          this.subscribeCustomer(_email.value, id, this);
          if (shouldSignup.checked) {
            this.subscribeCustomerToMailList(_email.value, id);
          }
        }
      }

      resetForm() {
        this.querySelectorAll(".pre-submit").forEach((el) => {
          el.classList.add("visually-hidden");
        });
        this.querySelector("p").classList.remove("visually-hidden");
        this.querySelector("#email_bis").value = "";
        this.querySelector("#fieldEmailConfirmation").value = "";
        this.querySelector("#fieldEmailConfirmation").classList.add(
          "visually-hidden",
        );

        setTimeout(() => {
          this.querySelectorAll(".pre-submit").forEach((el) => {
            // eslint-disable-next-line no-empty
            if (el.id === "valid-error") {
            } else {
              el.classList.remove("visually-hidden");
            }
          });
          this.querySelector("p").classList.add("visually-hidden");
        }, 4000);
      }

      async subscribeCustomer(_e, _id, _parent) {
        try {
          const url =
            "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=Um6rUb";

          const options = {
            method: "POST",
            headers: {
              accept: "application/json",
              revision: "2024-02-15",
              "content-type": "application/json",
            },
            body: JSON.stringify({
              data: {
                type: "back-in-stock-subscription",
                attributes: {
                  channels: ["EMAIL"],
                  profile: {
                    data: {
                      type: "profile",
                      attributes: {
                        email: `${_e.trim()}`,
                      },
                    },
                    email: `${_e.trim()}`,
                  },
                },
                relationships: {
                  variant: {
                    data: {
                      type: "catalog-variant",
                      id: `$shopify:::$default:::${_id.trim()}`,
                    },
                  },
                },
              },
            }),
          };

          const request = await fetch(url, options);
          _parent.setAttribute("data-sent", true);
          return request;
        } catch (err) {
          console.error(
            "uh oh! There was an error adding customer to the wait list: ",
            err,
          );
        }
      }

      async subscribeCustomerToMailList(_e, _id) {
        try {
          const url =
            "https://a.klaviyo.com/client/subscriptions/?company_id=Um6rUb";

          const options = {
            method: "POST",
            headers: {revision: "2024-02-15", "content-type": "application/json"},
            body: JSON.stringify({
              data: {
                type: "subscription",
                attributes: {
                  custom_source: `Beauty Secrets Sign Up - via API (Optional signup on BIS for ${_id})`,
                  profile: {
                    data: {
                      type: "profile",
                      attributes: {
                        email: `${_e}`,
                        properties: {emailValidated: true},
                      },
                    },
                  },
                },

                relationships: {list: {data: {type: "list", id: "U8ADFN"}}},
              },
            }),
          };

          const request = await fetch(url, options);
          return request;
        } catch (err) {
          console.error(
            "uh oh! There was an error adding customer to the wait list: ",
            err,
          );
        }
      }
    }

    customElements.define("notify-me-wrapper-qa", NotifyMeWrapperQuickAdd);

  }


  return Object.freeze({
    init,
  });
};
